var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLightLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3333 22.3333L35.3333 27.6667V22.3333H31.9803C31.6716 17.1213 27.7689 13 23 13C22.662 13 22.3283 13.0207 22 13.061V2H51V22.3333H41.3333ZM22 16C16.582 16 14 20.0817 14 24.5V29C14 32.9611 17 36.4 17.5 36.8C18 37.2 17.7419 39.6549 17.5 39.8C17.2581 39.9451 16.1487 40.3725 15.5 40.4805C7.85417 41.7531 5 44.2897 5 47.5C5 47.668 5.0127 47.8347 5.03711 48H38.9629C38.9873 47.8347 39 47.668 39 47.5C39 44.2897 36 41.5 28.5 40.4805C27.8513 40.3725 26.8268 39.9961 26.5 39.8C26.1732 39.6039 26 37.2 26.5 36.8C27 36.4 30 33.9611 30 29V24.5C30 20.0817 27.418 16 22 16Z",
    fill: "#F1B007"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightLesson);
export default __webpack_public_path__ + "static/media/icon_light_lesson.95ba0ced7faea0d47861730b9cc3acb7.svg";
export { ForwardRef as ReactComponent };